import React, { useState } from 'react'
import SendModal from '../../pages/messages/SendModal'
import { ChatBubbleOvalLeftEllipsisIcon } from '@heroicons/react/24/outline'

export const ChatButton = ({
  className = '',
  disabled = false,
  children,
  chatConfig = {},
  ...props
}) => {
  const [isChatModalOpen, setIsChatModalOpen] = useState(false)
  return (
    <>
      <button
        type="button"
        onClick={() => setIsChatModalOpen(true)}
        disabled={disabled}
        className={`flex-1 px-4 py-2 text-base font-medium text-white capitalize bg-gradient-to-r from-tertiary-700 to-tertiary-600 rounded-md hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-opacity flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
        {...props}
      >
        <span>{children}</span>
        <ChatBubbleOvalLeftEllipsisIcon className="w-6 h-6" />
      </button>
      <SendModal
        isOpen={isChatModalOpen}
        onClose={() => setIsChatModalOpen(false)}
        {...chatConfig}
      />
    </>
  )
}
